(function () {
  'use strict';

  if (window.__subBundleInit) return;
  window.__subBundleInit = true;

  var STORE_KEY = 'ink_bundle_pairs';
  var _syncLock = false;
  var _origFetch = window.fetch;

  function getPairs() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]'); } catch (e) { return []; }
  }
  function savePairs(p) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(p)); } catch (e) {}
  }

  async function fetchSellingPlan(handle) {
    try {
      var r = await _origFetch('/products/' + handle + '.js');
      var d = await r.json();
      var g = (d.selling_plan_groups || [])[0];
      var sp = g && g.selling_plans && g.selling_plans[0];
      return sp ? String(sp.id) : null;
    } catch (e) { return null; }
  }

  async function refreshCart() {
    var cart = null;
    try { cart = await (await _origFetch('/cart.js')).json(); } catch (e) {}

    // Theme cart drawer — openMiniCart: true tells it to slide open
    ['cart:updated', 'cart:refresh'].forEach(function (name) {
      [document, window].forEach(function (target) {
        target.dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: { cart: cart, openMiniCart: true }
        }));
      });
    });

    // UpCart app — fire known events so it refreshes and opens
    [document, window].forEach(function (target) {
      target.dispatchEvent(new CustomEvent('upcart:refresh', { bubbles: true, detail: { cart: cart } }));
      target.dispatchEvent(new CustomEvent('upcart:open',    { bubbles: true }));
      target.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { cart: cart } }));
    });

    // Fallback: simulate a click on the cart toggle button only when drawer is closed
    var cartBtn = document.querySelector('a[is="toggle-link"][aria-controls="mini-cart"]');
    if (cartBtn && cartBtn.getAttribute('aria-expanded') !== 'true') {
      cartBtn.click();
    }

    if (window.Shopify && window.Shopify.onCartUpdate && cart) {
      window.Shopify.onCartUpdate(cart);
    }
  }

  async function syncBundlePartner() {
    if (_syncLock) return;
    _syncLock = true;
    try {
      var pairs = getPairs();
      if (!pairs.length) { _syncLock = false; return; }

      var cart  = await (await _origFetch('/cart.js')).json();
      var items = cart.items || [];

      var groupMap = {};
      items.forEach(function (item) {
        var gid = (item.properties || {})['_bundle_group_id'];
        if (!gid) return;
        (groupMap[gid] = groupMap[gid] || []).push(item);
      });

      for (var i = 0; i < pairs.length; i++) {
        var pair  = pairs[i];
        var group = groupMap[pair.g];
        if (!group) continue;
        if (group.length === 1) {
          // One item was removed — remove its partner
          await _origFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: group[0].key, quantity: 0 })
          });
          await refreshCart();
        }
      }

      savePairs(pairs.filter(function (p) { return !!groupMap[p.g]; }));
    } catch (e) {
      console.warn('[SubBundle] syncBundlePartner:', e);
    } finally {
      _syncLock = false;
    }
  }

  // Intercept fetch to detect cart item removals
  window.fetch = function (resource, opts) {
    var url     = (typeof resource === 'string') ? resource : ((resource && resource.url) || '');
    var promise = _origFetch.apply(this, arguments);

    if (!_syncLock && /\/cart\/(change|update)\.js$/i.test(url) &&
        opts && /^post$/i.test((opts.method || ''))) {
      promise.then(function (res) {
        if (!res.ok) return;
        var body;
        try { body = JSON.parse(opts.body || 'null'); } catch (e) {}
        if (!body) return;
        var isRemoval =
          body.quantity === 0 || body.quantity === '0' ||
          (body.updates && Object.values(body.updates)
            .some(function (v) { return v === 0 || v === '0'; }));
        if (isRemoval) setTimeout(syncBundlePartner, 350);
      });
    }

    return promise;
  };

  document.addEventListener('DOMContentLoaded', function () {
    var block = document.querySelector('.sub-bundle-block[data-block-type="subscription-bundle"]');
    if (!block) return;

    var mainFormId          = block.dataset.mainFormId;
    var mainForm            = mainFormId ? document.getElementById(mainFormId) : null;
    if (!mainForm) return;

    var bundleVariantId     = block.dataset.bundleVariantId;
    var bundleHandle        = block.dataset.bundleProductHandle;
    var bundleSellingPlanId = block.dataset.bundleSellingPlanId || null;
    var checkboxId          = block.dataset.checkboxId;
    var checkbox            = checkboxId ? document.getElementById(checkboxId) : null;

    function isBundleSelected() {
      return checkbox ? checkbox.checked : true;
    }

    function setLoading(on) {
      var btn = mainForm.querySelector('[data-product-add-to-cart-button]');
      if (!btn) return;
      btn.disabled      = on;
      btn.ariaDisabled  = String(on);
      btn.style.opacity = on ? '0.6' : '';
    }

    mainForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var variantInput = mainForm.querySelector('[name="id"]');
      var qtyInput     = mainForm.querySelector('[name="quantity"]');
      if (!variantInput || !variantInput.value) return;

      var mainVariantId  = variantInput.value;
      var qty            = parseInt((qtyInput && qtyInput.value) || '1', 10);
      var addBundle      = isBundleSelected();
      var bundleGroupId  = addBundle ? ('bg_' + Date.now()) : null;

      // Only resolve selling plan if user opted into the bundle
      if (addBundle && !bundleSellingPlanId && bundleHandle) {
        bundleSellingPlanId = await fetchSellingPlan(bundleHandle);
      }

      var items = [
        {
          id:         parseInt(mainVariantId, 10),
          quantity:   qty,
          properties: addBundle ? { '_bundle_group_id': bundleGroupId } : {}
        }
      ];

      if (addBundle && bundleVariantId) {
        var bi = {
          id:         parseInt(bundleVariantId, 10),
          quantity:   qty,
          properties: { '_bundle_group_id': bundleGroupId }
        };
        if (bundleSellingPlanId) bi.selling_plan = parseInt(bundleSellingPlanId, 10);
        items.push(bi);
      }

      setLoading(true);
      try {
        // Use window.fetch (not _origFetch) so UpCart's fetch interceptor sees the add
        // and can refresh its own cart state/UI automatically.
        var resp = await window.fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body:    JSON.stringify({ items: items })
        });

        if (!resp.ok) {
          var errBody = await resp.json();
          throw new Error(errBody.description || 'Could not add to cart. Please try again.');
        }

        // Only track bundle pairs when bundle was actually added
        if (addBundle) {
          var pairs = getPairs();
          pairs.push({ g: bundleGroupId, m: mainVariantId, b: String(bundleVariantId || '') });
          savePairs(pairs);
        }

        await refreshCart();
      } catch (err) {
        console.error('[SubBundle]', err);
        alert(err.message);
      } finally {
        setLoading(false);
      }
    }, { capture: true });
  });
})();